import React, { PropTypes } from 'react';
import Lightbox from 'react-images';
import { isMobileOrTablet } from '../../../utils/browserDetection';

import { map } from './styles.module.css';

/**
 * Course Maps images presentational component.
 * This is both a gallery and lightbox component.
 */
const CourseMapImages = ({
  images,
  lightboxCurrentImage,
  lightboxIsOpen,
  lightboxOnClickPrev,
  lightboxOnClickNext,
  lightboxOnClose,
  onClick,
}) => (
  <div>
    {images.map((image, index) => ( // eslint-disable-next-line
      <div key={index} className={map}>
        <a href={image.source} onClick={event => onClick(event, index)}>
          <img src={image.large} alt={image.alt} />
        </a>
      </div>
    ))}
    {!isMobileOrTablet() &&
      <Lightbox
        currentImage={lightboxCurrentImage}
        images={images.map(image => ({ src: image.large }))}
        isOpen={lightboxIsOpen}
        onClickPrev={lightboxOnClickPrev}
        onClickNext={lightboxOnClickNext}
        onClose={lightboxOnClose}
      />
    }
  </div>
);

CourseMapImages.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      source: PropTypes.string.isRequired,
      large: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
    }),
  ).isRequired,
  lightboxCurrentImage: PropTypes.number,
  lightboxIsOpen: PropTypes.bool,
  lightboxOnClickPrev: PropTypes.func,
  lightboxOnClickNext: PropTypes.func,
  lightboxOnClose: PropTypes.func,
  onClick: PropTypes.func,
};

CourseMapImages.defaultProps = {
  lightboxCurrentImage: 0,
  lightboxIsOpen: false,
  lightboxOnClickPrev: () => {},
  lightboxOnClickNext: () => {},
  lightboxOnClose: () => {},
  onClick: () => {},
};

export default CourseMapImages;



// WEBPACK FOOTER //
// ./app/src/components/EventDetail/CourseMapImages/component.jsx